/// <amd-module name="VSSUI/TypeAhead" />
export { TypeAhead } from "./Components/TypeAhead/TypeAhead";
export { ITypeAheadProps } from "./Components/TypeAhead/TypeAhead.Props";
